import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";
import { useAuth } from "../lib/AuthContext.jsx";

// Header widget only. The actual sign-in / sign-up form lives on the
// dedicated Auth screen (v.goAuth).
export default function Account({ v }) {
  const { user, loading, signOut } = useAuth();

  // Avoid a "Connexion" → "user@mail" flash while the session is still
  // being resolved from Supabase on first load.
  if (loading) return <div style={pstyle("width:76px; height:24px;")} />;

  if (user) {
    return (
      <div style={pstyle("display:flex; align-items:center; gap:10px;")}>
        <button type="button" onClick={v.goProfile} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; cursor:pointer; text-align:left; font-size:12.5px; color:oklch(0.45 0.015 60); max-width:180px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;")}>{user.email}</button>
        {v.syncLoading && (
          <span style={pstyle("font-size:11px; color:oklch(0.56 0.015 60);")}>Synchronisation…</span>
        )}
        {!v.syncLoading && v.syncError && (
          <span title={v.syncError} style={pstyle("cursor:help; font-size:11px; color:oklch(0.55 0.09 30);")}>⚠ sync</span>
        )}
        <button type="button" onClick={() => signOut()} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; cursor:pointer; font-size:12.5px; color:oklch(0.46 0.075 55);")}>Déconnexion</button>
      </div>
    );
  }

  return (
    <div style={pstyle("display:flex; align-items:center; gap:14px;")}>
      {/* Guest favorites/notes already exist in memory/localStorage —
          reachable without an account, same aggregate view as signed in. */}
      <button type="button" onClick={v.goProfile} style={pstyle("background:none; border:none; padding:0; font:inherit; cursor:pointer; font-size:12.5px; color:oklch(0.45 0.015 60);")}>Favoris & notes</button>
      <Hoverable
        onClick={v.goAuth}
        style={pstyle("cursor:pointer; font-size:13px; border:1px solid oklch(0.9 0.01 85); border-radius:6px; padding:5px 12px; color:oklch(0.3 0.015 60);")}
        hoverStyle={{ borderColor: "oklch(0.46 0.075 55)", color: "oklch(0.46 0.075 55)" }}
      >
        Connexion
      </Hoverable>
    </div>
  );
}
